// CommonRangePicker.js
import React, { useRef } from "react";
import { DatePicker } from "antd";
import moment from "moment";
import { shallowEqual, useSelector } from "react-redux";
import { getDateTimeInZone, getSettingKey } from "./../../modules/Common/utils";

const { RangePicker } = DatePicker;

const RangePickerComponent = ({
    onChange,
    allowClear = false,
    disabled = false,
    // format = ,
    value,
    additionalClassName,
}) => {
    const { currentState } = useSelector((state) => ({ currentState: state.basicSettings }), shallowEqual);
    const { entity } = currentState;
    const timezone = getSettingKey(entity, "Basic", "timezone");
    
    console.log("🚀 ~ value:", value)

        return (
            <RangePicker
                ranges={{
                    Today: [moment(getDateTimeInZone(timezone)?.split("T")[0]), moment(getDateTimeInZone(timezone)?.split("T")[0])],
                    Yesterday: [moment(getDateTimeInZone(timezone)?.split("T")[0])?.subtract(1, "day"), moment(getDateTimeInZone(timezone)?.split("T")[0])?.subtract(1, "day")],
                    "Last 7 Days": [moment(getDateTimeInZone(timezone)?.split("T")[0])?.subtract(7, "days"), moment(getDateTimeInZone(timezone)?.split("T")[0])],
                    "Last 14 Days": [moment(getDateTimeInZone(timezone)?.split("T")[0])?.subtract(14, "days"), moment(getDateTimeInZone(timezone)?.split("T")[0])],
                    "Last 30 Days": [moment(getDateTimeInZone(timezone)?.split("T")[0])?.subtract(30, "days"), moment(getDateTimeInZone(timezone)?.split("T")[0])],
                }}
                allowClear={allowClear}
                disabled={disabled}
                className={`pb-3 px-5 text-secondary rounded border-secondary ${additionalClassName}`}
                // format={format}
                value={value}
                onChange={onChange}
            />
        );
};

export default RangePickerComponent;
